function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { StringFormat } from "../Clipboard.types";
import { ClipboardUnavailableException, CopyFailureException, NoPermissionException, PasteFailureException } from "./Exceptions";
import { base64toBlob, blobToBase64Async, findHtmlInClipboardAsync, findImageInClipboardAsync, getImageSizeFromBlobAsync, htmlToPlainText, isClipboardPermissionDeniedAsync } from "./Utils";
export default {
  get name() {
    return 'ExpoClipboard';
  },
  getStringAsync: function getStringAsync(options) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var clipboardItems, blob, text, _clipboardItems, _blob, blobText;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (navigator.clipboard) {
              _context.next = 2;
              break;
            }
            throw new ClipboardUnavailableException();
          case 2:
            _context.prev = 2;
            _context.t0 = options.preferredFormat;
            _context.next = _context.t0 === StringFormat.HTML ? 6 : 19;
            break;
          case 6:
            _context.next = 8;
            return navigator.clipboard.read();
          case 8:
            clipboardItems = _context.sent;
            _context.next = 11;
            return findHtmlInClipboardAsync(clipboardItems);
          case 11:
            blob = _context.sent;
            if (blob) {
              _context.next = 16;
              break;
            }
            _context.next = 15;
            return navigator.clipboard.readText();
          case 15:
            return _context.abrupt("return", _context.sent);
          case 16:
            _context.next = 18;
            return new Response(blob).text();
          case 18:
            return _context.abrupt("return", _context.sent);
          case 19:
            _context.next = 21;
            return navigator.clipboard.readText();
          case 21:
            text = _context.sent;
            if (!(!text || text === '')) {
              _context.next = 33;
              break;
            }
            _context.next = 25;
            return navigator.clipboard.read();
          case 25:
            _clipboardItems = _context.sent;
            _context.next = 28;
            return findHtmlInClipboardAsync(_clipboardItems);
          case 28:
            _blob = _context.sent;
            _context.next = 31;
            return _blob === null || _blob === void 0 ? void 0 : _blob.text();
          case 31:
            blobText = _context.sent;
            text = htmlToPlainText(blobText !== null && blobText !== void 0 ? blobText : '');
          case 33:
            return _context.abrupt("return", text);
          case 34:
            _context.next = 52;
            break;
          case 36:
            _context.prev = 36;
            _context.t1 = _context["catch"](2);
            _context.t2 = _context.t1.name === 'NotAllowedError';
            if (_context.t2) {
              _context.next = 43;
              break;
            }
            _context.next = 42;
            return isClipboardPermissionDeniedAsync();
          case 42:
            _context.t2 = _context.sent;
          case 43:
            if (!_context.t2) {
              _context.next = 45;
              break;
            }
            throw new NoPermissionException();
          case 45:
            _context.prev = 45;
            return _context.abrupt("return", window.clipboardData.getData('Text'));
          case 49:
            _context.prev = 49;
            _context.t3 = _context["catch"](45);
            return _context.abrupt("return", Promise.reject(new Error('Unable to retrieve item from clipboard')));
          case 52:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 36], [45, 49]]);
    }))();
  },
  // TODO: (barthap) The `setString` was deprecated in SDK 45. Remove this function in a few SDK cycles.
  setString: function setString(text) {
    var textField = document.createElement('textarea');
    textField.textContent = text;
    document.body.appendChild(textField);
    textField.select();
    try {
      document.execCommand('copy');
      return true;
    } catch (_unused2) {
      return false;
    } finally {
      document.body.removeChild(textField);
    }
  },
  setStringAsync: function setStringAsync(text, options) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var clipboardItemInput;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = options.inputFormat;
            _context2.next = _context2.t0 === StringFormat.HTML ? 3 : 22;
            break;
          case 3:
            if (navigator.clipboard) {
              _context2.next = 5;
              break;
            }
            throw new ClipboardUnavailableException();
          case 5:
            _context2.prev = 5;
            clipboardItemInput = createHtmlClipboardItem(text);
            _context2.next = 9;
            return navigator.clipboard.write([clipboardItemInput]);
          case 9:
            return _context2.abrupt("return", true);
          case 12:
            _context2.prev = 12;
            _context2.t1 = _context2["catch"](5);
            _context2.t2 = _context2.t1.name === 'NotAllowedError';
            if (_context2.t2) {
              _context2.next = 19;
              break;
            }
            _context2.next = 18;
            return isClipboardPermissionDeniedAsync();
          case 18:
            _context2.t2 = _context2.sent;
          case 19:
            if (!_context2.t2) {
              _context2.next = 21;
              break;
            }
            throw new NoPermissionException();
          case 21:
            throw new CopyFailureException(_context2.t1.message);
          case 22:
            _context2.prev = 22;
            if (navigator.clipboard) {
              _context2.next = 25;
              break;
            }
            throw new Error();
          case 25:
            _context2.next = 27;
            return navigator.clipboard.writeText(text);
          case 27:
            return _context2.abrupt("return", true);
          case 30:
            _context2.prev = 30;
            _context2.t3 = _context2["catch"](22);
            return _context2.abrupt("return", _this.setString(text));
          case 33:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[5, 12], [22, 30]]);
    }))();
  },
  hasStringAsync: function hasStringAsync() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return clipboardHasTypesAsync(['text/plain', 'text/html']);
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  getImageAsync: function getImageAsync(_options) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var clipboardItems, blob, _yield$Promise$all, _yield$Promise$all2, data, size;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (navigator.clipboard) {
              _context4.next = 2;
              break;
            }
            throw new ClipboardUnavailableException();
          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return navigator.clipboard.read();
          case 5:
            clipboardItems = _context4.sent;
            _context4.next = 8;
            return findImageInClipboardAsync(clipboardItems);
          case 8:
            blob = _context4.sent;
            if (blob) {
              _context4.next = 11;
              break;
            }
            return _context4.abrupt("return", null);
          case 11:
            _context4.next = 13;
            return Promise.all([blobToBase64Async(blob), getImageSizeFromBlobAsync(blob)]);
          case 13:
            _yield$Promise$all = _context4.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            data = _yield$Promise$all2[0];
            size = _yield$Promise$all2[1];
            return _context4.abrupt("return", {
              data: data,
              size: size
            });
          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](2);
            _context4.t1 = _context4.t0.name === 'NotAllowedError';
            if (_context4.t1) {
              _context4.next = 27;
              break;
            }
            _context4.next = 26;
            return isClipboardPermissionDeniedAsync();
          case 26:
            _context4.t1 = _context4.sent;
          case 27:
            if (!_context4.t1) {
              _context4.next = 29;
              break;
            }
            throw new NoPermissionException();
          case 29:
            throw new PasteFailureException(_context4.t0.message);
          case 30:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 20]]);
    }))();
  },
  setImageAsync: function setImageAsync(base64image) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var blob;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (navigator.clipboard) {
              _context5.next = 2;
              break;
            }
            throw new ClipboardUnavailableException();
          case 2:
            _context5.prev = 2;
            // we set it always to `image/png` because it's the only format supported by the clipboard
            // but it seems to work even when provided jpeg data
            blob = base64toBlob(base64image, 'image/png');
            _context5.next = 6;
            return navigator.clipboard.write([new ClipboardItem(_defineProperty({}, blob.type, blob))]);
          case 6:
            _context5.next = 11;
            break;
          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](2);
            throw new CopyFailureException(_context5.t0.message);
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 8]]);
    }))();
  },
  hasImageAsync: function hasImageAsync() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return clipboardHasTypesAsync(['image/png', 'image/jpeg']);
          case 2:
            return _context6.abrupt("return", _context6.sent);
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  addClipboardListener: function addClipboardListener() {},
  removeClipboardListener: function removeClipboardListener() {}
};
/**
 * Resolves to true if clipboard has one of provided {@link types}.
 * @throws `ClipboardUnavailableException` if AsyncClipboard API is not available
 * @throws `NoPermissionException` if user denied permission
 */
function clipboardHasTypesAsync(_x) {
  return _clipboardHasTypesAsync.apply(this, arguments);
}
function _clipboardHasTypesAsync() {
  _clipboardHasTypesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(types) {
    var clipboardItems;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (navigator.clipboard) {
            _context7.next = 2;
            break;
          }
          throw new ClipboardUnavailableException();
        case 2:
          _context7.prev = 2;
          _context7.next = 5;
          return navigator.clipboard.read();
        case 5:
          clipboardItems = _context7.sent;
          return _context7.abrupt("return", clipboardItems.flatMap(function (item) {
            return item.types;
          }).some(function (type) {
            return types.includes(type);
          }));
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](2);
          _context7.t1 = _context7.t0.name === 'NotAllowedError';
          if (_context7.t1) {
            _context7.next = 16;
            break;
          }
          _context7.next = 15;
          return isClipboardPermissionDeniedAsync();
        case 15:
          _context7.t1 = _context7.sent;
        case 16:
          if (!_context7.t1) {
            _context7.next = 18;
            break;
          }
          throw new NoPermissionException();
        case 18:
          throw _context7.t0;
        case 19:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[2, 9]]);
  }));
  return _clipboardHasTypesAsync.apply(this, arguments);
}
function createHtmlClipboardItem(htmlString) {
  return new ClipboardItem({
    // @ts-ignore `Blob` from `lib.dom.d.ts` and the one from `@types/react-native` differ
    'text/html': new Blob([htmlString], {
      type: 'text/html'
    }),
    // @ts-ignore `Blob` from `lib.dom.d.ts` and the one from `@types/react-native` differ
    'text/plain': new Blob([htmlToPlainText(htmlString)], {
      type: 'text/plain'
    })
  });
}